import { render, staticRenderFns } from "./compImagen.vue?vue&type=template&id=ecd6389c"
import script from "./compImagen.vue?vue&type=script&lang=js"
export * from "./compImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports